'use client'

import React, { useState, useEffect } from 'react'
import styles from './Dashboard.module.scss'
import { DashboardClientProps } from './Dashboard.interface'

const DashboardClient: React.FC<DashboardClientProps> = ({ iframeConfigs }) => {
  // Create state for all iframe sources
  const [iframeSrcs, setIframeSrcs] = useState<(string | undefined)[]>(
    Array(iframeConfigs.length).fill(undefined),
  )

  useEffect(() => {
    // We delay setting the src to ensure DOM element is ready before the browser starts loading.
    const timer = setTimeout(() => {
      setIframeSrcs(iframeConfigs.map((config) => config.src))
    }, 50) // 50ms delay is usually sufficient
    return () => clearTimeout(timer)
  }, [iframeConfigs]) // Re-run if configs change

  return (
    <div className={styles.contentWrapper}>
      {/* Map over the configs to render the iframes */}
      {iframeConfigs.map((config, index) => (
        <div
          className={styles.iframeContainer}
          key={index}
          style={{
            // Apply horizontal scroll only if minWidth is set
            // this is set because not all dashboards are responsive
            // so this will enable users to scroll right if dashboard gets cropped by narrow screen
            overflowX: config.minWidth ? 'auto' : 'hidden',
            background: config.backgroundColor || 'transparent',
          }}
        >
          <iframe
            id={`dashboard-iframe-${index}`}
            className={styles.iframe}
            src={iframeSrcs[index]}
            title={config.title}
            style={{
              height: config.height,
              minWidth: config.minWidth || '100%',
            }}
            scrolling={config.scrolling || 'no'}
            onError={() => console.error(`${config.title} failed to load`)}
            // Conditionally apply the onContextMenu handler
            onContextMenu={config.disableContextMenu ? (e) => e.preventDefault() : undefined}
          />
        </div>
      ))}
    </div>
  )
}

export default DashboardClient
